import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import FilterBy from './FilterBy';
import * as devOrderAction from '../../Pages/DevlopmentOrder/store/DevelopmentOrder.action';
import { checkArray } from '../helper';
import SeasonFilter from '../SeasonFilter/SeasonFilter';

function ProductFilter({ products, onAddProduct, show, handleClose, disabledBtn }) {
  const reducerData = useSelector((redState) => redState);
  const { Measuremets } = reducerData;
  const { t } = useTranslation('common');
  const { allOpenProducts } = Measuremets;
  const dispatch = useDispatch();
  const [state, setState] = useState({
    selectedProducts: [],
    allProducts: [],
    loader: false,
    filterActive: false,
    searchText: '',
    filterObj: null,
    selectedAll: false,
  });

  const { selectedProducts, allProducts, loader, filterActive, searchText, filterObj } = state;
  useEffect(() => {
    const Init = async () => {
      setState((prevState) => ({
        ...prevState,
        loader: true,
      }));
      await dispatch(devOrderAction.fetchAllProducts());
      setState((prevState) => ({
        ...prevState,
        loader: false,
      }));
    };

    Init();
  }, []);

  const handleSelectAll = () => {
    const ids = allProducts.map((obj) => obj._id);
    setState((prevSate) => ({
      ...prevSate,
      selectedProducts: state?.selectedAll ? [] : [...ids],
      selectedAll: !state?.selectedAll,
    }));
  };

  const handleSelectNone = () => {
    setState((prevSate) => ({
      ...prevSate,
      selectedProducts: [],
    }));
  };

  const handleProductSelect = (event, product) => {
    const isChecked = event.target.checked;
    let updatedSelectedProducts;

    if (isChecked) {
      updatedSelectedProducts = [...selectedProducts, product];
    } else {
      updatedSelectedProducts = selectedProducts.filter((selectedProduct) => selectedProduct !== product);
    }

    setState((prevSate) => ({
      ...prevSate,
      selectedProducts: updatedSelectedProducts,
      selectedAll: state?.allProducts?.length === updatedSelectedProducts.length,
    }));
  };

  const filterDataFunc = async (dataFilter, srcData) => {
    return srcData.filter((item) => {
      const filterKeys = Object.keys(dataFilter);
      const filterObject = filterKeys.reduce((obj, key) => {
        obj[key] = dataFilter[key];
        return obj;
      }, {});

      return Object.keys(filterObject).every((key) => {
        if (key === 'suppliers') {
          const filteredArray = item[key].filter((value) => filterObject[key].includes(value));
          return !!checkArray(filteredArray);
        }
        return filterObject[key].includes(item[key]);
      });
    });
  };

  useEffect(() => {
    const refreshProducts = async () => {
      const searchedProducts = allOpenProducts.filter((obj) => obj.isArchived === false && obj.number.toLowerCase().includes(searchText));
      const filteredProducts = isEmpty(filterObj) ? searchedProducts : await filterDataFunc(filterObj, searchedProducts);
      setState((prevSate) => ({
        ...prevSate,
        allProducts: filteredProducts,
      }));
    };

    refreshProducts();
  }, [allOpenProducts]);

  const handleInputChange = async (event) => {
    const filterValue = event.target.value.trim().toLowerCase();
    const filteredProducts = allOpenProducts.filter((product) => product.number.toLowerCase().includes(filterValue));
    let filteredData = filteredProducts;
    if (!isEmpty(filterObj)) {
      filteredData = await filterDataFunc(filterObj, filteredProducts);
    }
    setState((prevSate) => ({
      ...prevSate,
      allProducts: filteredData,
      searchText: filterValue,
    }));
  };

  const forLibFilter = async (data) => {
    const dataFilter = Object.fromEntries(Object.entries(data).filter(([key, value]) => value.length > 0));
    setState((prevState) => ({
      ...prevState,
      loader: true,
    }));
    let productList = allOpenProducts;
    if (searchText !== '') {
      productList = allOpenProducts.filter((product) => product.number.toLowerCase().includes(searchText));
    }
    const filteredData = await filterDataFunc(dataFilter, productList);
    setState((prevSate) => ({
      ...prevSate,
      allProducts: filteredData,
      filterActive: !isEmpty(dataFilter),
      filterObj: dataFilter,
      loader: false,
    }));
  };
  const showFilters = () => {
    return <FilterBy onApplyClick={forLibFilter} filterActive={filterActive} />;
  };

  return (
    <Modal className="common-custom-modal add-product-modal modal-md product-filter-modal" show={show} onHide={handleClose}>
      <Modal.Header className="modal-header-custom">
        <Modal.Title>
          <span>{t('PRODUCT_FILTTER.ADD_PRODUCT')}</span>
        </Modal.Title>
        <span onClick={handleClose} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body className="add-product-body">
        <div className="modal-body-content">
          <SeasonFilter
            loader={loader}
            handleSelectAll={handleSelectAll}
            handleInputChange={handleInputChange}
            onAddProduct={onAddProduct}
            handleProductSelect={handleProductSelect}
            selectedProducts={selectedProducts}
            handleClose={handleClose}
            allProducts={allProducts}
            disabledBtn={disabledBtn}
            handleSelectNone={handleSelectNone}
            isShowFilter
            showFilters={showFilters}
            isSeasonFocused
            state={state}
          />
        </div>
        <div className="common-model-footer">
          <button
            type="button"
            aria-label="save"
            onClick={() => {
              onAddProduct(selectedProducts);
              setState((prevSate) => ({
                ...prevSate,
                selectedAll: false,
              }));
            }}
            className="btn p-0"
            disabled={disabledBtn}
          >
            <i className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ProductFilter;
